import React from 'react'

export default function SingerCard({ song, onClick, innerRef }) {
  return (
    <div className="artist-btn-box" onClick={(e) => {e.preventDefault(); onClick()}} ref={innerRef}>
        <img className="artistBtnPhoto" src={`https://starboxkod.com/api/profile-image/${song}`}/>
        <div className="artistBtnName">{song}</div>
    </div>
  )
}
